import React, { Component } from 'react';
import { Grid, TextField, Button } from '@material-ui/core';
import { Restaurant } from '../../../api/models/RestaurantData';
import { validatePostalCode, WrongPostalCodeFormatText, validatePhoneNumber, WrongPhoneNumberFormatText } from '../../Common';
import { postalCodeLookup } from './PostalCodeLookup';
import PhoneNumberInput from '../../../Common/PhoneNumberInput';
import PostalCodeInput from '../../../Common/PostalCodeInput';

type Props = {
    update: (r: Restaurant) => void,
    chosenBusinessName: string,
    updateSignUpData: (r: Restaurant) => void,
    signUpData: Restaurant
}

type State = {
    restaurant: Restaurant,
    postalCodeFormatError: boolean,
    phoneNumberFormatError: boolean
}

class RestaurantInformationForm extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            restaurant: {
                suburb: "",
                name: this.props.chosenBusinessName,
                postalCode: "",
                stateCode: "",
                street: "",
                streetNumber: "",
                phoneNumber: ""
            },
            postalCodeFormatError: false,
            phoneNumberFormatError: false,
        }
    }

    componentDidMount() {
        this.props.signUpData ?
            this.setState({ restaurant: this.props.signUpData })
            : this.props.updateSignUpData(this.state.restaurant)
    }

    render() {
        return (
            <div>
                <Grid container style={{ padding: "15px" }}>
                    <Grid item sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            value={this.props.chosenBusinessName}
                            label="Restaurant Name"
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                            disabled={true}
                        ></TextField>
                    </Grid>

                    <Grid item sm={2}></Grid><Grid item sm={2}></Grid>
                    <Grid item xs={6} sm={3}>
                        <TextField
                            onChange={(e) => this.setState({ restaurant: { ...this.state.restaurant, streetNumber: e.target.value } })}
                            value={this.state.restaurant.streetNumber}
                            onBlur={() => this.props.updateSignUpData(this.state.restaurant)}
                            label="Street Number*"
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                        ></TextField>
                    </Grid>

                    <Grid item xs={6} sm={5}>
                        <TextField
                            onChange={(e) => this.setState({ restaurant: { ...this.state.restaurant, street: e.target.value } })}
                            value={this.state.restaurant.street}
                            onBlur={() => this.props.updateSignUpData(this.state.restaurant)}
                            label="Street*"
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                        ></TextField>
                    </Grid>
                    <Grid item sm={2}></Grid><Grid item sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            onChange={(e) => this.setState({ restaurant: { ...this.state.restaurant, suburb: e.target.value } })}
                            value={this.state.restaurant.suburb}
                            onBlur={() => this.props.updateSignUpData(this.state.restaurant)}
                            label="Suburb*"
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                        ></TextField>
                    </Grid>
                    <Grid item sm={2}></Grid><Grid item sm={2}></Grid>
                    <Grid item xs={6} sm={4}>
                        <PostalCodeInput
                            onChange={(value: string, isValid: boolean) => {
                                this.setState({ restaurant: { ...this.state.restaurant, postalCode: value }, postalCodeFormatError: !isValid },
                                    () => {
                                        if (isValid) {
                                            let statel = postalCodeLookup(this.state.restaurant.postalCode)
                                            this.setState({ restaurant: { ...this.state.restaurant, stateCode: statel } })
                                        }
                                    })
                            }}
                            onBlur={() => this.props.updateSignUpData(this.state.restaurant)}
                            value={this.state.restaurant.postalCode}
                            label="Postal Code*"
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <TextField
                            onChange={(e) => this.setState({ restaurant: { ...this.state.restaurant, stateCode: e.target.value } })}
                            value={this.state.restaurant.stateCode}
                            onBlur={() => this.props.updateSignUpData(this.state.restaurant)}
                            label="State Code*"
                            disabled={!this.state.postalCodeFormatError && this.state.restaurant.stateCode !== ''}
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                        ></TextField>
                    </Grid>
                    <Grid item sm={2}></Grid>

                    <Grid item sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <PhoneNumberInput
                            onBlur={() => this.props.updateSignUpData(this.state.restaurant)}
                            onChange={(value: string, isValid: boolean) => {
                                this.setState({ restaurant: { ...this.state.restaurant, phoneNumber: value }, phoneNumberFormatError: !isValid })
                            }}
                            value={this.state.restaurant.phoneNumber}
                            label={"Phone Number*"}
                        />
                    </Grid>
                    <Grid item sm={2}></Grid>


                    <Grid item sm={3} md={4}></Grid>
                    <Grid item xs={12} sm={6} md={4} style={{ paddingTop: '15px', textAlign: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={this.state.phoneNumberFormatError || this.state.postalCodeFormatError
                                || this.state.restaurant.name === ""
                                || this.state.restaurant.phoneNumber === ""
                                || this.state.restaurant.postalCode === ""
                                || this.state.restaurant.stateCode === ""
                                || this.state.restaurant.street === ""
                                || this.state.restaurant.streetNumber === ""
                                || this.state.restaurant.suburb === ""}
                            onClick={() => { this.props.update({ ...this.state.restaurant, name: this.props.chosenBusinessName }) }}>Next</Button>
                    </Grid>
                    <Grid item sm={3} md={4}></Grid>

                </Grid>
            </div>
        );
    }
}

export default RestaurantInformationForm;